export const rowsPerPage = 5;
export const statusRequestInterval = 5000;
export const maxPossibleItemQty = 999999;

export const errorVariables = [
  'errorMinOrderQuantityText',
  'errorMaxOrderQuantityText',
  'errorIncrementQuantityText',
  'errorInvalidVariantText',
  'errorAvailableQuantityText',
];
export const quantityErrors = [
  'errorMinOrderQuantityText',
  'errorMaxOrderQuantityText',
  'errorAvailableQuantityText',
];

export const errorKeyMap = {
  maxRowLimitReachedError: 'errorMaxRowsLimitReachedText',
  emptyCSVError: 'errorEmptyCSVText',
  invalidVariantsError: 'errorIncorrectVariantText', // not to be confused with 'errorInvalidVariantText', this map is only used when csv is empty
  invalidQuantityError: 'errorInvalidQuantityText',
};

export const mrOrderIDAttributionKey = '_mrcaOrderID';

